import { createContext, useContext } from 'react';

import type { CrispContextState } from './interface-crisp';

export const crispContext = createContext<CrispContextState>(null);

export const useContextCrisp = () => {
  return useContext(crispContext);
};
